import { flexibleTicket, cancelForAnyReason } from '@eti/products';
import { useTranslation } from '@eti/providers';
import { LinkButton } from '@etg/wings';
import { css } from '@eti/styles';
import { DangerousHtmlContent } from '@eti/components';
import { useToggle } from '../../../../../../../common/custom-hooks/toggle';
import { ModalDialog } from './ModalDialog';

const dangerousHtmlContentStyles = css`
  line-height: 21px;

  ul {
    list-style: disc;
    margin: 16px 0;
    padding-left: 24px;

    li {
      margin-bottom: 8px;
    }
  }
`;

interface TicketReadMoreProps {
  className?: string;
  ticketId?: number;
}

export const TicketReadMore = ({ className, ticketId }: TicketReadMoreProps) => {
  const { t } = useTranslation();
  const { isOpen, handleOpen, handleClose } = useToggle();

  let readMoreLinkText: string;
  let ticketReadmoreContent: string;
  let ticketTitle: string;
  switch (ticketId) {
    case flexibleTicket.id:
      readMoreLinkText = t('Result.Page.FlexibleTicket.ReadMore.Text');
      ticketReadmoreContent = t('flexibleTicketReadMoreModalContent');
      ticketTitle = t('flexibleTicketHeaderTitle');
      break;
    case cancelForAnyReason.id:
      readMoreLinkText = t('Result.Page.CancelForAnyReasonTicket.ReadMore.Text');
      ticketReadmoreContent = t('cancelForAnyReasonReadMoreModalContent');
      ticketTitle = t('cancelForAnyReasonTitle');
      break;
    default:
      return null;
  }

  return (
    <>
      <LinkButton
        aria-controls={`ticket-${ticketId}`}
        className={className}
        data-attributes="click focus"
        data-testid="linkButton_testid"
        onClick={handleOpen}
      >
        {readMoreLinkText}
      </LinkButton>
      <ModalDialog
        handleClose={handleClose}
        id={`ticket-${ticketId}`}
        isOpen={isOpen}
        title={ticketTitle}
      >
        <DangerousHtmlContent
          className={dangerousHtmlContentStyles}
          content={ticketReadmoreContent}
        />
      </ModalDialog>
    </>
  );
};
